import WidgetTypes from '../enums/WidgetTypes';
import TempCache from '../enums/TempCache';
import { ChatState } from '../enums/Enum';
import Cookies from '../hooks/Cookies';

export default class ChatCookieHandler {
    DeleteCookie() {
        Cookies.set(TempCache.CHAT_STATE, ChatState.Closed);
        // Delete the CHAT_IN_PROGRESS COOKIE that was set on chat startup in invitation
        Cookies.del(TempCache.VISITORINFO_IN_PROGRESS_COOKIE);
        Cookies.del(TempCache.CHAT_IN_PROGRESS_COOKIE);
        Cookies.del(WidgetTypes.ExitPopup);
        Cookies.del(WidgetTypes.PreChat);
        Cookies.del(WidgetTypes.VideoGreetInvitation);
        Cookies.del(TempCache.SHOW_OPERATOR_NOT_FOUND_OVERLAY);
        Cookies.del('apexchat_live_contactInfo');
        // chat's over; if they leave the page, it starts fresh
        Cookies.del(TempCache.TRANSFER_TO_LIVE_AGENT);
        Cookies.del(TempCache.USER_REACT_ON_LOC_DISCLAIMER);
        Cookies.del(TempCache.CHAT_STATE);
        Cookies.del(TempCache.CHAT_ID_COOKIE);
        Cookies.del(TempCache.CHAT_TOKEN_COOKIE);
        Cookies.del(TempCache.IS_PAGE_REFRESHED); //missing state to clean up when chat ends
        Cookies.del(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE);
        Cookies.del(TempCache.PreChat_Message_Sent);
        Cookies.del(WidgetTypes.DOMUIController); //remove domuicontroller cookies as it refresh it will create a new one
        Cookies.del('apexchat_video_greet_maximized'); // delete video greet cookies
        ApexChat.preLoadedOptions = null;
        if (typeof ApexChatStartData !== 'undefined') {
            ApexChatStartData = null;
        }
        ApexChat.IsShowDisclaimeOverlay = false;
        ApexChat.chatArray = []; //CHAT-8365 After chat end array should be re-initiated;
        ApexChat.allHistoryMessages = []; //After chat end all history messages should be clear
    }
}
